import { render, staticRenderFns } from "./ProjectRejectedLifecycleSetter.vue?vue&type=template&id=613d0770"
import script from "./ProjectRejectedLifecycleSetter.vue?vue&type=script&lang=ts"
export * from "./ProjectRejectedLifecycleSetter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports